import React from 'react';
import './visitevirtuelle.css';

import cours from '../../asserts/images/cours.jpg';
import escal from '../../asserts/images/escal.jpg';
import BLOC9 from '../../asserts/images/BLOC9.jpg';
import BLOC2 from '../../asserts/images/bloc2.jpg';
import BLOC3 from '../../asserts/images/BLOC3.jpg';
import BLOC4 from '../../asserts/images/BLOC4.jpg';
import BLOC5 from '../../asserts/images/BLOC5.jpg';
import BLOC6 from '../../asserts/images/BLOC6.jpg';
import BLOC7 from '../../asserts/images/BLOC7.jpg';
import BLOC10 from '../../asserts/images/BLOC10.jpg';
import BLOC11 from '../../asserts/images/BLOC11.jpg';
import BLOC12 from '../../asserts/images/isimmINTER.jpg';
import BLOC13 from '../../asserts/images/isimmINTER2.jpg';
import BLOC14 from '../../asserts/images/escal2.jpg';
import BLOC15 from '../../asserts/images/INTER.jpg';



import ex1 from '../../asserts/images/ex1.jpg';
import ex2 from '../../asserts/images/ex6.jpg';
import ex3 from '../../asserts/images/ex3.jpg';
import ex4 from '../../asserts/images/ex4.jpg';
import ex5 from '../../asserts/images/ex5.jpg';

import bib1 from '../../asserts/images/bib1.jpg';
import BIB2 from '../../asserts/images/BIB2.jpg';
import BIB3 from '../../asserts/images/BIB3.jpg';
import BIB4 from '../../asserts/images/BIB4.jpg';
import BIB5 from '../../asserts/images/BIB5.jpg';
import BIB6 from '../../asserts/images/BIB6.jpg';


import C1 from '../../asserts/images/c1.jpg';
import C2 from '../../asserts/images/c2.jpg';
import C3 from '../../asserts/images/C3.jpg';
import C4 from '../../asserts/images/C4.jpg';
import C5 from '../../asserts/images/C5.jpg';
import C6 from '../../asserts/images/C6.jpg';

import emphi from '../../asserts/images/emphi.jpg';
import emphi2 from '../../asserts/images/emphi2.jpg';
import emphi3 from '../../asserts/images/emphi3.jpg';

import jardin from '../../asserts/images/BLO13.jpg';
import { Link } from 'react-router-dom';
import { Footer, Header } from '../index';

function visitevirtuelle(props) {
  return (
    <>
      <Header />
     
      <div className='containerINFO'>
        <div className='introrg'>  </div>
        <div className="container-fluid text-white text-center" style={{ position: 'relative', marginTop: '-130px', marginBottom: '100px' }}>
          <h1 style={{fontFamily:'fantasy',fontSize:'45px'}}className="container-fluid text-white text-center " id='h1visite'>VISITER ISIMM EN LIGNE</h1>
          <p className="container-fluid text-white text-center" ><Link className='linkorg' to="/">Accueil</Link> <span>{'>'}</span><Link className='linkorg'
            to="/"> Visite virtuelle </Link>  </p></div>
      </div>
      <div className="VISTE">
        <div className="row">
          <div className="col-md-6">
            <div id="carouselBasicExample1"  className="carousel slide carousel-fade w-100 carousel-box-shadow" style={{ marginBottom: '20px' }} data-bs-ride="carousel">
            {/* Indicators */}
            <div className="carousel-indicators">
                <button
                    type="button"
                    data-bs-target="#carouselBasicExample1"
                    data-bs-slide-to="0"
                    className="active"
                    aria-current="true"
                    aria-label="Slide 1"
                ></button>
                <button
                    type="button"
                    data-bs-target="#carouselBasicExample1"
                    data-bs-slide-to="1"
                    aria-label="Slide 2"
                ></button>
                <button
                    type="button"
                    data-bs-target="#carouselBasicExample1"
                    data-bs-slide-to="2"
                    aria-label="Slide 3"
                ></button>
                <button
                    type="button"
                    data-bs-target="#carouselBasicExample1"
                    data-bs-slide-to="3"
                    aria-label="Slide 4"
                ></button>

                  <button
                    type="button"
                    data-bs-target="#carouselBasicExample1"
                    data-bs-slide-to="4"
                    aria-label="Slide 5"
                ></button>
                <button
                    type="button"
                    data-bs-target="#carouselBasicExample1"
                    data-bs-slide-to="5"
                    aria-label="Slide 6"
                ></button>
                <button
                type="button"
                data-bs-target="#carouselBasicExample1"
                data-bs-slide-to="6"
                aria-label="Slide 7"
            ></button>
                 <button
                    type="button"
                    data-bs-target="#carouselBasicExample1"
                    data-bs-slide-to="7"
                    aria-label="Slide 8"
                ></button>
                <button
                    type="button"
                    data-bs-target="#carouselBasicExample1"
                    data-bs-slide-to="8"
                    aria-label="Slide 9"
                ></button>
                <button
                    type="button"
                    data-bs-target="#carouselBasicExample1"
                    data-bs-slide-to="8"
                    aria-label="Slide 9"
                ></button>
                <button
                    type="button"
                    data-bs-target="#carouselBasicExample1"
                    data-bs-slide-to="9"
                    aria-label="Slide 10"
                ></button>
                <button
                    type="button"
                    data-bs-target="#carouselBasicExample1"
                    data-bs-slide-to="10"
                    aria-label="Slide 11"
                ></button>
                <button
                    type="button"
                    data-bs-target="#carouselBasicExample1"
                    data-bs-slide-to="11"
                    aria-label="Slide 12"
                ></button>
                  <button
                    type="button"
                    data-bs-target="#carouselBasicExample1"
                    data-bs-slide-to="12"
                    aria-label="Slide 13"
                ></button>
                <button
                    type="button"
                    data-bs-target="#carouselBasicExample1"
                    data-bs-slide-to="13"
                    aria-label="Slide 14"
                ></button>
                <button
                    type="button"
                    data-bs-target="#carouselBasicExample1"
                    data-bs-slide-to="14"
                    aria-label="Slide 15"
                ></button>
                 <button
                    type="button"
                    data-bs-target="#carouselBasicExample1"
                    data-bs-slide-to="15"
                    aria-label="Slide 16"
                ></button>
            </div>

              
              {/* Carrousel 1 */}
              {/* Inner */}
              <div className="carousel-inner">
                {/* Single item */}
                <div className="carousel-item active">
                  <img src={BLOC15} className="d-block w-100" alt="Interieure" />
                  <div className="carousel-caption d-none d-md-block">
                  <h5 className='titreh5'>Interieure de l'ISIMM</h5>
                  </div>
                </div>

                {/* Single item */}
                <div className="carousel-item">
                  <img src={BLOC5} className="d-block w-100" alt="Interieure" />
                  <div className="carousel-caption d-none d-md-block">
                  <h5 className='titreh5'>Interieure de l'ISIMM</h5>
                  </div>
                </div>

                <div className="carousel-item">
                  <img src={BLOC7} className="d-block w-100" alt="Interieure" />
                  <div className="carousel-caption d-none d-md-block">
                  <h5 className='titreh5'>Interieure de l'ISIMM</h5>
                  </div>
                </div>




                {/* Single item */}
                <div className="carousel-item">
                  <img src={escal} className="d-block w-100" alt="Interieure" />
                  <div className="carousel-caption d-none d-md-block">
                    <h5 className='titreh5'>Interieure de l'ISIMM</h5>
                  </div>
                </div>

                {/* Single item */}
                <div className="carousel-item ">
                  <img src={BLOC2} className="d-block w-100" alt="Interieure" />
                  <div className="carousel-caption d-none d-md-block">
                  <h5 className='titreh5'>Interieure de l'ISIMM</h5>
                  </div>
                </div>

                {/* Single item */}
                <div className="carousel-item ">
                  <img src={BLOC9} className="d-block w-100" alt="Interieure" />
                  <div className="carousel-caption d-none d-md-block">
                  <h5 className='titreh5'>Interieure de l'ISIMM</h5>
                  </div>
                </div>

                {/* Single item */}
                <div className="carousel-item ">
                  <img src={jardin} className="d-block w-100" alt="Interieure" />
                  <div className="carousel-caption d-none d-md-block">
                  <h5 className='titreh5'>Interieure de l'ISIMM</h5>
                  </div>
                </div>

                {/* Single item */}
                <div className="carousel-item ">
                  <img src={BLOC4} className="d-block w-100" alt="Interieure" />
                  <div className="carousel-caption d-none d-md-block">
                  <h5 className='titreh5'>Interieure de l'ISIMM</h5>
                  </div>
                </div>

                {/* Single item */}
                <div className="carousel-item ">
                  <img src={BLOC3} className="d-block w-100" alt="Interieure" />
                  <div className="carousel-caption d-none d-md-block">
                  <h5 className='titreh5'>Interieure de l'ISIMM</h5>
                  </div>
                </div>

                {/* Single item */}
                <div className="carousel-item ">
                  <img src={BLOC6} className="d-block w-100" alt="Interieure" />
                  <div className="carousel-caption d-none d-md-block">
                  <h5 className='titreh5'>Interieure de l'ISIMM</h5>
                  </div>
                </div>

                {/* Single item */}
                <div className="carousel-item ">
                  <img src={BLOC10} className="d-block w-100" alt="Interieure" />
                  <div className="carousel-caption d-none d-md-block">
                  <h5 className='titreh5'>Interieure de l'ISIMM</h5>
                  </div>
                </div>

                {/* Single item */}

                <div className="carousel-item ">
                  <img src={BLOC11} className="d-block w-100" alt="Interieure" />
                  <div className="carousel-caption d-none d-md-block">
                  <h5 className='titreh5'>Interieure de l'ISIMM</h5>
                  </div>
                </div>

                {/* Single item */}
                <div className="carousel-item ">
                  <img src={cours} className="d-block w-100" alt="Interieure" />
                  <div className="carousel-caption d-none d-md-block">
                  <h5 className='titreh5'>Interieure de l'ISIMM</h5>
                  </div>
                </div>

                  {/* Single item */}
                  <div className="carousel-item ">
                  <img src={BLOC12} className="d-block w-100" alt="Interieure" />
                  <div className="carousel-caption d-none d-md-block">
                  <h5 className='titreh5'>Interieure de l'ISIMM</h5>
                  </div>
                </div>
                  {/* Single item */}
                  <div className="carousel-item ">      
                  <img src={BLOC13} className="d-block w-100" alt="Interieure" />
                  <div className="carousel-caption d-none d-md-block">
                  <h5 className='titreh5'>Interieure de l'ISIMM</h5>
                  </div>
                </div>
                    {/* Single item */}
                    <div className="carousel-item ">
                  <img src={BLOC14} className="d-block w-100" alt="Interieure" />
                  <div className="carousel-caption d-none d-md-block">
                  <h5 className='titreh5'>Interieure de l'ISIMM</h5>
                  </div>
                </div>



              </div>
              {/* Inner */}

              {/* Controls */}
              <button className="carousel-control-prev" type="button" data-bs-target="#carouselBasicExample1" data-bs-slide="prev">
                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Previous</span>
              </button>
              <button className="carousel-control-next" type="button" data-bs-target="#carouselBasicExample1" data-bs-slide="next">
                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Next</span>
              </button>
            </div>
          </div>

          <div className="col-md-6">
            <div id="carouselBasicExample2"  className="carousel slide carousel-fade w-100 carousel-box-shadow" style={{ marginBottom: '20px' }} data-bs-ride="carousel">
            {/* Indicators */}
            <div className="carousel-indicators">
                <button
                    type="button"
                    data-bs-target="#carouselBasicExample2"
                    data-bs-slide-to="0"
                    className="active"
                    aria-current="true"
                    aria-label="Slide 1"
                ></button>
                <button
                    type="button"
                    data-bs-target="#carouselBasicExample2"
                    data-bs-slide-to="1"
                    aria-label="Slide 2"
                ></button>
                <button
                    type="button"
                    data-bs-target="#carouselBasicExample2"
                    data-bs-slide-to="2"
                    aria-label="Slide 3"
                ></button>

                <button
                    type="button"
                    data-bs-target="#carouselBasicExample2"
                    data-bs-slide-to="3"
                    aria-label="Slide 4"
                ></button>

                <button
                    type="button"
                    data-bs-target="#carouselBasicExample2"
                    data-bs-slide-to="4"
                    aria-label="Slide 5"
                ></button>


  
                </div>

              
              {/* Carrousel 2 */}
              {/* Inner */}
              <div className="carousel-inner">
                {/* Single item */}
                <div className="carousel-item active">
                  <img src={ex5} className="d-block w-100" alt="Exterieur" />
                  <div className="carousel-caption d-none d-md-block">
                  <h5 className='titreh5'>Exterieur de l'ISIMM</h5>
                  </div>
                </div>

                {/* Single item */}
                <div className="carousel-item">
                  <img src={ex4} className="d-block w-100" alt="Exterieur" />
                  <div className="carousel-caption d-none d-md-block">
                  <h5 className='titreh5'>Exterieur de l'ISIMM</h5>
                  </div>
                </div>

                {/* Single item */}
                <div className="carousel-item">
                  <img src={ex1} className="d-block w-100" alt="Exterieur" />
                  <div className="carousel-caption d-none d-md-block">
                  <h5 className='titreh5'>Exterieur de l'ISIMM</h5>
                  </div>
                </div>

              {/* Single item */}
              <div className="carousel-item">
                  <img src={ex3} className="d-block w-100" alt="Exterieur" />
                  <div className="carousel-caption d-none d-md-block">
                  <h5 className='titreh5'>Exterieur de l'ISIMM</h5>
                  </div>
                </div>

                 {/* Single item */}
              <div className="carousel-item">
                  <img src={ex2} className="d-block w-100" alt="Exterieur" />
                  <div className="carousel-caption d-none d-md-block">
                  <h5 className='titreh5'>Exterieur de l'ISIMM</h5>
                  </div>
                </div>

                

          

              </div>
              {/* Inner */}

              {/* Controls */}
              <button className="carousel-control-prev" type="button" data-bs-target="#carouselBasicExample2" data-bs-slide="prev">
                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Previous</span>
              </button>
              <button className="carousel-control-next" type="button" data-bs-target="#carouselBasicExample2" data-bs-slide="next">
                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Next</span>
              </button>
            </div>
          </div>
    


          <div className="col-md-6">
            <div id="carouselBasicExample3"  className="carousel slide carousel-fade w-100 carousel-box-shadow" style={{ marginBottom: '20px' }} data-bs-ride="carousel">
            {/* Indicators */}
            <div className="carousel-indicators">
                <button
                    type="button"
                    data-bs-target="#carouselBasicExample3"
                    data-bs-slide-to="0"
                    className="active"
                    aria-current="true"
                    aria-label="Slide 1"
                ></button>
                <button
                    type="button"
                    data-bs-target="#carouselBasicExample3"
                    data-bs-slide-to="1"
                    aria-label="Slide 2"
                ></button>
                <button
                    type="button"
                    data-bs-target="#carouselBasicExample3"
                    data-bs-slide-to="2"
                    aria-label="Slide 3"
                ></button>

                <button
                    type="button"
                    data-bs-target="#carouselBasicExample3"
                    data-bs-slide-to="3"
                    aria-label="Slide 4"
                ></button>

                <button
                    type="button"
                    data-bs-target="#carouselBasicExample3"
                    data-bs-slide-to="4"
                    aria-label="Slide 5"
                ></button>
                <button
                    type="button"
                    data-bs-target="#carouselBasicExample3"
                    data-bs-slide-to="5"
                    aria-label="Slide 6"
                ></button>


  
                </div>

              
              {/* Carrousel 2 */}
              {/* Inner */}
              <div className="carousel-inner">
                {/* Single item */}
                <div className="carousel-item active">
                <img src={BIB6} className="d-block w-100" alt="Bibliothèque" />
                  <div className="carousel-caption d-none d-md-block">
                  <h5 className='titreh5'>Bibliothèque</h5>
                  </div>
                </div>

                {/* Single item */}
                <div className="carousel-item">
                <img src={bib1} className="d-block w-100" alt="Bibliothèque" />
                  <div className="carousel-caption d-none d-md-block">
                  <h5 className='titreh5'>Bibliothèque</h5>
                  </div>
                </div>

                {/* Single item */}
                <div className="carousel-item">
                <img src={BIB2} className="d-block w-100" alt="Bibliothèque" />
                  <div className="carousel-caption d-none d-md-block">
                  <h5 className='titreh5'>Bibliothèque</h5>
                  </div>
                </div>

              {/* Single item */}
              <div className="carousel-item">
              <img src={BIB3} className="d-block w-100" alt="Bibliothèque" />
                  <div className="carousel-caption d-none d-md-block">
                  <h5 className='titreh5'>Bibliothèque</h5>
                  </div>
                </div>

                 {/* Single item */}
              <div className="carousel-item">
              <img src={BIB4} className="d-block w-100" alt="Bibliothèque" />
                  <div className="carousel-caption d-none d-md-block">
                  <h5 className='titreh5'>Bibliothèque</h5>
                  </div>
                </div>
                    {/* Single item */}
              <div className="carousel-item">
              <img src={BIB5} className="d-block w-100" alt="Bibliothèque" />
                  <div className="carousel-caption d-none d-md-block">
                  <h5 className='titreh5'>Bibliothèque</h5>
                  </div>
                </div>

              
              </div>
              {/* Inner */}

              {/* Controls */}
              <button className="carousel-control-prev" type="button" data-bs-target="#carouselBasicExample3" data-bs-slide="prev">
                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Previous</span>
              </button>
              <button className="carousel-control-next" type="button" data-bs-target="#carouselBasicExample3" data-bs-slide="next">
                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Next</span>
              </button>
            </div>
          </div>









           <div className="col-md-6">
            <div id="carouselBasicExample4"  className="carousel slide carousel-fade w-100 carousel-box-shadow" style={{ marginBottom: '20px' }} data-bs-ride="carousel">
            
            {/* Indicators */}
            <div className="carousel-indicators">
                <button
                    type="button"
                    data-bs-target="#carouselBasicExample4"
                    data-bs-slide-to="0"
                    className="active"
                    aria-current="true"
                    aria-label="Slide 1"
                ></button>
                <button
                    type="button"
                    data-bs-target="#carouselBasicExample4"
                    data-bs-slide-to="1"
                    aria-label="Slide 2"
                ></button>
                <button
                    type="button"
                    data-bs-target="#carouselBasicExample4"
                    data-bs-slide-to="2"
                    aria-label="Slide 3"
                ></button>
                <button
                    type="button"
                    data-bs-target="#carouselBasicExample4"
                    data-bs-slide-to="3"
                    aria-label="Slide 4"
                ></button>

               <button
                    type="button"
                    data-bs-target="#carouselBasicExample4"
                    data-bs-slide-to="4"
                    aria-label="Slide 5"
                ></button>
                <button
                    type="button"
                    data-bs-target="#carouselBasicExample4"
                    data-bs-slide-to="5"
                    aria-label="Slide 6"
                ></button>
                <button
                    type="button"
                    data-bs-target="#carouselBasicExample4"
                    data-bs-slide-to="6"
                    aria-label="Slide 7"
                  ></button>               
                   <button
                  type="button"
                  data-bs-target="#carouselBasicExample4"
                  data-bs-slide-to="7"
                  aria-label="Slide 8"
                  ></button>                
                  <button
                  type="button"
                  data-bs-target="#carouselBasicExample4"
                  data-bs-slide-to="8"
                  aria-label="Slide 9"
              ></button>
                
                </div>

              
              {/* Carrousel 4 */}
              {/* Inner */}
              <div className="carousel-inner">

                {/* Single item */}
                <div className="carousel-item active">
                  <img src={C3} className="d-block w-100" alt="Classe" />
                  <div className="carousel-caption d-none d-md-block">
                    <h5>Classes et Amphi</h5>
                  </div>
                </div>

                {/* Single item */}
                <div className="carousel-item">
                  <img src={C1} className="d-block w-100" alt="Classe" />
                  <div className="carousel-caption d-none d-md-block">
                  <h5>Classes et Amphi</h5>
                  </div>
                </div>

                {/* Single item */}
                <div className="carousel-item">
                  <img src={C2} className="d-block w-100" alt="Classe" />
                  <div className="carousel-caption d-none d-md-block">
                  <h5>Classes et Amphi</h5>
                  </div>
                </div>

                {/* Single item */}
                <div className="carousel-item">
                  <img src={C4} className="d-block w-100" alt="Classe" />
                  <div className="carousel-caption d-none d-md-block">
                  <h5>Classes et Amphi</h5>
                  </div>
                </div>


                 {/* Single item */}
                 <div className="carousel-item">
                  <img src={C5} className="d-block w-100" alt="Classe" />
                  <div className="carousel-caption d-none d-md-block">
                  <h5>Classes et Amphi</h5>
                  </div>
                </div>

                {/* Single item */}
                <div className="carousel-item">
                  <img src={C6} className="d-block w-100" alt="Classe" />
                  <div className="carousel-caption d-none d-md-block">
                  <h5>Classes et Amphi</h5>
                  </div>
                </div>

                  {/* Single item */}
                  <div className="carousel-item">
                  <img src={emphi} className="d-block w-100" alt="Classe" />
                  <div className="carousel-caption d-none d-md-block">
                  <h5>Classes et Amphi</h5>
                  </div>
                </div>

                {/* Single item */}
                <div className="carousel-item">
                  <img src={emphi3} className="d-block w-100" alt="Classe" />
                  <div className="carousel-caption d-none d-md-block">
                  <h5>Classes et Amphi</h5>
                  </div>
                </div>

                {/* Single item */}
                <div className="carousel-item">
                  <img src={emphi2} className="d-block w-100" alt="Classe" />
                  <div className="carousel-caption d-none d-md-block">
                  <h5>Classes et Amphi</h5>
                  </div>
                </div>


              </div>
              {/* Inner */}

              {/* Controls */}
              <button className="carousel-control-prev" type="button" data-bs-target="#carouselBasicExample4" data-bs-slide="prev">
                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Previous</span>
              </button>
              <button className="carousel-control-next" type="button" data-bs-target="#carouselBasicExample4" data-bs-slide="next">
                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Next</span>
              </button>
            </div>
          </div>
          

        </div>
      </div>
      <Footer />
    </>
  );
}

export default visitevirtuelle;
